import React from 'react';
import './Numput.css';

class Numput extends React.Component {

   /* you have these props, which access to
   this.props.field, // { name, value, onChange, onBlur }
   this.props.form   // { touched, errors, values, setXXXX, handleXXXX, dirty, isValid, status, ...etc }.
    */
    constructor(props) {
      super(props);
      let x = props.value;
      if (isNaN(props.value)) {
        x = 0;
      }
      this.state = {
        counter: x
      };
      this.updateStateAndField(x);
    }
    // increment button pushed
    handleIncrement = event => {
      let p = parseInt(this.state.counter, 10);
      this.updateStateAndField(p+1);
    };
    // decrement button pushed
    handleDecrement = event => {
      let p = parseInt(this.state.counter, 10)
      // do not allow for negative numbers here
      if (p >= 1) {
        this.updateStateAndField(p-1);
      }
    };
    // input text change
    handleChange = event => {
      let p = parseInt(event.target.value, 10);
      this.updateStateAndField(p);
    };
    // updates the field in Formik's internal representation
    updateStateAndField = (newVal) => {
      // originally, this state was set by a method this.setState(); but this did not work correctly. 
      this.state.counter = newVal;
      this.setState({
        counter: newVal
      });
      this.props.form.setFieldValue(this.props.field.name, newVal);
    };
  
    render() {
      
      return (
        <div className="numput-widget">
          <div>
            <label className={'numput-inner-label ' + this.props.labelClass}>{this.props.label}</label>
            <div className="numput-controls">
              <button className="btn-numput btn-numput-decrease" type="button" onClick={this.handleDecrement}></button>
              <input className="input-hide-browser-extras numput-number" name={this.props.field.name} type="number" value={this.state.counter} onChange={this.handleChange}/>
              <button className="btn-numput btn-numput-increase" type="button" onClick={this.handleIncrement}></button>
            </div>
          </div>
        </div>
        
      );
    }
  }
  
  export default Numput;